// extracted by mini-css-extract-plugin
export var displayNone = "_ty-6";
export var imgContainer = "_ty-2";
export var overflowHidden = "_ty-3";
export var productInfoCardButtonContainer = "_ty-5";
export var productTitleText = "_ty-4";
export var rightArrow = "_ty-1";
export var rightArrowContainer = "_ty-0";